(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gelmix-price-tax-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gelmix-tax-price')) {
    class GelmixTaxPrice extends HTMLElement {
      static forms = new WeakSet();

      connectedCallback() {
        this.connectToTheme = this.connectToTheme || this.bindTheme.bind(this);
        this.bindTheme();
        queueMicrotask(this.connectToTheme);
        document.addEventListener('theme:all:loaded', this.connectToTheme, { once: true });
        document.addEventListener('DOMContentLoaded', this.connectToTheme, { once: true });
      }

      disconnectedCallback() {
        document.removeEventListener('theme:all:loaded', this.connectToTheme);
        document.removeEventListener('DOMContentLoaded', this.connectToTheme);
      }

      bindTheme() {
        const container = this.closest('[data-js-product-container]');
        const form = container?.querySelector('[data-js-product-form]');
        const bus = window.themeCore?.EventBus;
        if (!form?.id || !bus || GelmixTaxPrice.forms.has(form)) return;
        GelmixTaxPrice.forms.add(form);
        bus.listen(`form:${form.id}:change-variant`, ({ currentVariant, container: updatedContainer }) => {
          updatedContainer?.querySelectorAll('gelmix-tax-price').forEach((priceNote) => {
            priceNote.updateVariant(currentVariant);
          });
        });
      }

      updateVariant(variant) {
        const knownIds = this.dataset.variantIds.split(',');
        const eligible = variant && knownIds.includes(String(variant.id)) && Number.isInteger(variant.price);
        this.hidden = !eligible;
        if (!eligible) return;
        const grossCents = Math.round(variant.price * 1055 / 1000);
        const formatted = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(grossCents / 100);
        this.textContent = `${formatted} TTC`;
      }
    }
    customElements.define('gelmix-tax-price', GelmixTaxPrice);
  }
  } catch(e) { console.error(e); }
})();

})();
